import React from 'react';
import { CronMonitor } from './CronMonitor';

const CronMonitorPage = () => {
    return <CronMonitor />;
};

export default CronMonitorPage;